<template>
  <div class="p_doc_box">
    <div class="topOperation">
        <div class="top-left">
            <div><ShowNavHead/></div>
        </div>
    </div>
    <div class="main-con">
        <div class="crumbs">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item>知识库</el-breadcrumb-item>
                <el-breadcrumb-item>管理制度</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="p_doc_content">
            <div class="doc_box">
                <el-menu
                :default-active="activeIndex"
                class="el-menu-doc" @select="handleSelect"
                @open="handleOpen"
                @close="handleClose">
                    <el-menu-item index="1">
                        <span slot="title">综合性管理制度</span>
                    </el-menu-item>
                    <el-menu-item index="2">
                        <span slot="title">财务管理制度</span>
                    </el-menu-item>
                </el-menu>
                <div class="doc_box_table">
                    <div class="p_doc_table" v-if="activeIndex == '1'">
                        <el-table
                        ref="multipleTable"
                        :data="tableData"
                        tooltip-effect="dark"
                        style="width: 100%"
                        @selection-change="handleSelectionChange">
                            <el-table-column type="selection" width="55"></el-table-column>
                            <el-table-column label="排序" width="60">
                                <template slot-scope="{row}">{{ row.indexNum }}</template>
                            </el-table-column>
                            <el-table-column label="标题">
                                <template slot-scope="{row}">
                                    <a v-if="row.title == '系统管理制度'" class="txt01" @click="dtlDocJump">{{ row.title }}</a>
                                    <div class="p_doc_txts">
                                        <div class="txt_item">
                                            <span>所属分类: {{ row.classify }}</span>
                                        </div>
                                        <div class="txt_item">
                                            <span>发布时间: {{ row.datetime }}</span>
                                        </div>
                                    </div>
                                </template>
                            </el-table-column>
                        </el-table>
                        <div class="block" v-if="tableData.length>0">
                            <el-pagination
                                @current-change="changeBPage"
                                :current-page.sync="listQuery.currpage"
                                :page-size="listQuery.perpage"
                                @size-change="handleSizeChange"
                                :page-sizes="[10, 20, 50, 100]"
                                layout="total,sizes,prev,pager,next,jumper"
                                :total="total"
                            ></el-pagination>
                        </div>
                    </div>
                    <div class="doc_empty" v-if="activeIndex != '1'">
                        <el-empty description="暂无内容"></el-empty>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
        listQuery:{
            currpage:1,
            perpage:10
        },
      tabPosition: 'left',
      tableData:[
        {
            indexNum:'1',
            auther:'',
            department:'',
            datetime:'2022-10-13',
            classify:'系统管理制度',
            title:'系统管理制度'
        }
      ],
      videoVisible:false,
      activeNames: ['1'],
      multipleSelection: [],
      total:0,
      activeIndex:'1'
    }
  },
  created() {
      this.total = this.tableData.length
  },
  methods: {
    handleSelect(key, keyPath) {
        this.activeIndex = key
        // console.log('hh',key, keyPath)
    },
    handleOpen(key, keyPath) {
        console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
        console.log(key, keyPath);
    },
    //分页
    changeBPage(val){
        this.listQuery.currpage = Number(val)
        // this.getList()
    },
    handleSizeChange(val) {
      this.listQuery.currpage = 1
      this.listQuery.perpage = Number(val)
    //   this.getList()
    },
    handleSelectionChange(val){
        this.multipleSelection = val
    },
    videoHandle(){
        this.videoVisible = true
        this.$nextTick(() => {
            this.$refs.myVideo.pause()
        })
    },
    handleChange(val) {
        console.log(val)
      },
      dtlDocJump(){
          this.$router.push({ 
            path: '/dtlSysDoc'})
        //   let { href } = this.$router.resolve({
        //     path: "/dtlDoc"
        // })
        // window.open(href, '_blank')
      }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.p_doc_content .el-menu-item.is-active{
    background-color: #ebfaf5;
    color:#19bd92;
}
.class-video,.class-video img {
    width: 100%;
}
.p_doc_content .el-tabs__item{
    height: 30px;
    line-height: 30px;
}
.p_doc_content .el-collapse{
    margin-top: 15px;
}
.p_doc_table .txt01{
    font-size: 14px;
    color:#333;
    cursor: pointer;
}
.p_doc_table .txt01:hover{
    color:#19bd92;
}
</style>
<style scoped>
.doc_box{
    display: flex;
}
.doc_box .el-menu-doc{
    width: 200px;
    margin-right: 20px;
}
.doc_box_table{
    flex: 1;
}
.p_doc_content .txt03{
    width: 60%;
    font-size: 14px;
    padding-left: 25px;
    color:#19bd92;
    cursor: pointer;
}
.p_doc_txts{
    display: flex;
    flex-wrap: wrap;
    font-size: 12px;
    color:#999;
}
.txt_item{
    margin-right: 15px;
}
.doc_btn{
    display: flex;
    justify-content: flex-end;
}
.class-video{
    max-height:800px;
}
.p_doc_content{
    min-height: 800px;
    padding: 20px;
    background-color: #fff;
}
.el-pagination{
  background-color: #fff;
}
</style>